export type Unpacked<T> = T extends (infer U)[] ? U : T;

export const SkeletonCount = 10;
export const PageSize = 10;
export const TokenRefreshInterval = 25; // minutos

export const QueryKeys = {
	applications: "applications",
	application: "applications",
	establishments: "establishments",
	establishment: "establishment",
	users: "users",
	user: "user",
	peoples: "peoples",
	people: "people",
	transactions: "transactions",
	transaction: "transaction",
	recognizeConfigs: "recognizeConfigs",
	recognizeConfig: "recognizeConfig",
};

export const DefaultLocation = { latitude: -30.033056, longitude: -51.23 };
export const CPFMask = "999.999.999-99";
export const CNPJMask = "99.999.999/9999-99";
export const TelefoneMask = "(99) 99999-9999";
export const DataMask = "99/99/9999";
